import ENUM from '../ENUM'

const configFormInputType = {
    [ENUM().comparisonSurveyIds]: {
        inputType: 'checkbox:years',
    },
    [ENUM().benchmarks]: {
        inputType: 'checkbox:benchmarks',
    },
    [ENUM().parentDataRanking]: {
        inputType: 'select',
    },
    [ENUM().ranking]: {
        inputType: 'select',
    },
    [ENUM().locked]: {
        inputType: 'checkbox:boolean',
    },
    [ENUM().chartType]: {
        inputType: 'select',
    },
    [ENUM().excludeNonNumeric]: {
        inputType: 'checkbox:boolean',
    },
    [ENUM().removeBaseLimit]: {
        inputType: 'text:int',
    },
    [ENUM().display]: {
        inputType: 'text:int',
    },
    [ENUM().kpiPageQuestionId]: {
        inputType: 'select',
    },
    [ENUM().kpiId]: {
        inputType: 'select',
    },
    [ENUM().overallShowScore]: {
        inputType: 'checkbox',
    },
}

export default configFormInputType
